import { useState, useEffect } from "react";
import SmoothScroll from "../components/site/SmoothScroll";
import { Loader } from "../components/site/Loader";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { EditorialMarquee } from "../components/site/EditorialMarquee";
import { About } from "../components/site/About";
import { WhyChooseUs } from "../components/site/WhyChooseUs";
import { Menu } from "../components/site/Menu";
import { FullMenu } from "../components/site/FullMenu";
import { Services } from "../components/site/Services";
import { Ordering } from "../components/site/Ordering";
import { BookingPayment } from "../components/site/BookingPayment";
import { Gallery } from "../components/site/Gallery";
import { Testimonials } from "../components/site/Testimonials";
import { FAQ } from "../components/site/FAQ";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { BackToTop } from "../components/site/BackToTop";

let hasIntroPlayed = false;

export default function Home() {
  const [loaded, setLoaded] = useState(() => hasIntroPlayed);

  useEffect(() => {
    if (hasIntroPlayed) return;
    const t = setTimeout(() => {
      hasIntroPlayed = true;
      setLoaded(true);
    }, 2200);
    return () => clearTimeout(t);
  }, []);

  return (
    <SmoothScroll>
      <div className="bg-cream text-ink grain-overlay">
        <Loader done={loaded} />
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <About />
          <WhyChooseUs />
          <Menu />
          <FullMenu />
          <Services />
          <Ordering />
          <BookingPayment />
          <Gallery />
          <Testimonials />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <BackToTop />
      </div>
    </SmoothScroll>
  );
}
